import { render, staticRenderFns } from "./ArticleDateTime.vue?vue&type=template&id=8a60b5f4&"
import script from "./ArticleDateTime.vue?vue&type=script&lang=js&"
export * from "./ArticleDateTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports